import React from 'react'
import { UnitMaster } from '../../../../Units/reducer'

export const CancelSubscriptionDescription: React.FC<{
  selectedRow: UnitMaster | null
}> = ({ selectedRow }) => (
  <div>
    Are you sure you want to cancel the subscription for{' '}
    <span
      style={{
        color: 'red',
        fontWeight: 'bold',
      }}
    >
      UNIT {selectedRow?.unitNumber}
    </span>
    ?
  </div>
)
